import(/* webpackMode: "eager", webpackExports: ["EventPage"] */ "/vercel/path0/src/app/beta/events/[eventSlug]/_components/EventPage.tsx");
